module.exports = __webpack_public_path__ + "img/simon.4b65e144.jpeg";